/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { MyProfilePreferredCommunicationChannelWidgetComponent } from './myprofile-preferred-communication-channel-widget.component'
import { RESTRICT_GLOBAL_UI_CHANGES } from '../../../pidx-utils/src/lib/helpers/restrictGlobalUIChanges.injectionToken'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'

@NgModule({
  imports: [CommonModule, TranslatePipe, PorscheDesignSystemModule],
  declarations: [MyProfilePreferredCommunicationChannelWidgetComponent],
  exports: [MyProfilePreferredCommunicationChannelWidgetComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MyProfilePreferredCommunicationChannelWidgetModule {
  static forRoot(restrictGlobalUIChanges: boolean): ModuleWithProviders<MyProfilePreferredCommunicationChannelWidgetModule> {
    return {
      ngModule: MyProfilePreferredCommunicationChannelWidgetModule,
      providers: [{ provide: RESTRICT_GLOBAL_UI_CHANGES, useValue: restrictGlobalUIChanges }],
    }
  }
}
